import React from "react";
import Proof from "../components/ProofOfVaccination";
import VaccineDoses from "../components/VaccineDoses";

interface IProps {}

const VaccineLicense: React.FC<IProps> = () => {
  return (
    <div className="vaccine-license">
      <div className="proof-of-vaccination-wrapper">
        <Proof.ProofOfVaccination>
          <Proof.ClientSectionTop />
          <Proof.ClientSectionMiddle />
          <Proof.ClientSectionBottom />
        </Proof.ProofOfVaccination>

        <div className="vaccination-detail-wrapper">
          <h4 className="title">Vaccination</h4>

          {Array.from({ length: 2 }, (_, i) => (
            <VaccineDoses index={i} key={i} />
          ))}

          <div className="vaccination-detail-card notice text-xl">
            <div className="pb-5 text-gray-600">
              This Certificate is issued by the{" "}
              <span className="text-navy-900 text-decoration-underline">Health Ministry</span> of Islamic
              Republic of Iran as the international proof for vaccination.
            </div>
            <div className="text-navy-900">
              Note: The only acceptable URL for this result is
              https://health.gov.ir/...
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VaccineLicense;
